export const obtainLanguage = (fallback: string) => {
  if (typeof window === 'undefined') {
    return fallback;
  }
  const cookieLangIndex = document.cookie.indexOf('wixLanguage=');
  return cookieLangIndex >= 0
    ? document.cookie.substring(cookieLangIndex + 12, cookieLangIndex + 14)
    : fallback;
};

export const serializeRequestParams = (params: {
  [s: string]: any;
}): string => {
  return Object.entries(params).reduce(
    (paramsString, [paramName, value], index) => {
      return paramsString + `${index ? '&' : '?'}${paramName}=${value}`;
    },
    '',
  );
};

export const getReferralInfo = () => {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);

  return (
    searchParams.get('referralInfo') ??
    searchParams.get('referralAdditionalInfo') ??
    'no_referral_provided'
  );
};
